<template lang="html">
    <div class="page" id="newMessage">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/messages.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>New message</h2>
                <ul class="links">
                    <li>
                        <a
                            class="cancel"
                            @click.prevent="goToLocation({ name: 'proMessages' })"
                            href="#"
                        >
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <select
                @change="resetTo('player')"
                class="button light msButton2"
                v-model="form.player"
                :class="{ half: !isSinglePlayer, selected: form.player }"
            >
                <option value="">Select player</option>
                <option :value="player.id" v-for="player in players" :key="player.id">
                    {{ player.first_name }} {{ player.last_name }}
                </option>
            </select>

            <select
                @change="resetTo('group')"
                class="button light half msButton2"
                v-model="form.group"
                v-if="!isSinglePlayer"
                :class="{ selected: form.group }"
            >
                <option value="">Select Group</option>
                <option
                    :value="group.id"
                    v-for="group in groups"
                    :key="group.id"
                    :disabled="groupHasNoMembers(group)"
                >
                    {{ groupLabel(group) }}
                </option>
            </select>

            <has-error class="info error" :form="form" field="player"></has-error>
            <has-error class="info error" :form="form" field="group"></has-error>
            <has-error class="info error" :form="form" field="msg"></has-error>

            <div class="messageBox" :class="{ active: msgActive }">
                <textarea-autosize
                    placeholder="Type your message here"
                    v-model="form.msg"
                    @focus.native="msgActive = true"
                    @blur.native="msgActive = false"
                    name="name"
                />

                <div class="offer" v-if="offer">
                    {{ offer.title }}
                </div>

                <div class="msgSelectSurround half" style="z-index: 1; position: relative">
                    <select
                        class="button light small msgButton first"
                        v-model="form.offer_id"
                        @change="selectOffer"
                    >
                        <option value="">Add offer</option>
                        <option v-for="offer in offers" :value="offer.id" :key="offer.id">
                            {{ offer.title }}
                        </option>
                    </select>
                    <plus-icon class="icon" />
                </div>

                <div v-if="!form.image_url" style="position: relative">
                    <android-file-picker
                        id="content-message-image"
                        mode="single"
                        type="Image"
                        v-if="androidFilePickerOpen"
                    ></android-file-picker>
                    <label
                        class="button light half small addImage msgButton last"
                        @click="openFileAndroid"
                    >
                        Add Image
                        <input
                            type="file"
                            @change="selectImage"
                            accept="image/png, image/jpeg, image/jpg, image/gif"
                        />
                        <plus-icon class="icon" />
                    </label>
                </div>

                <label
                    @click.prevent="removeImage"
                    class="button light half small addImage msgButton last"
                    :class="{ red: form.image_url }"
                    v-else
                >
                    Remove Image

                    <span
                        style="
                            width: 8px;
                            height: 1px;
                            background: white;
                            display: block;
                            border-radius: 2px;
                            position: absolute;
                            right: 10px;
                            top: 19px;
                        "
                    ></span>
                </label>

                <span style="display: block; clear: both"></span>

                <img v-if="form.image_url" class="attachedImage" :src="form.image_url" />
            </div>

            <button
                :disabled="form.busy"
                @click.prevent="sendMessage"
                v-if="form.msg.length > 0"
                class="button"
                type="button"
                name="button"
            >
                {{ form.busy ? "Please wait..." : "Send message" }}
            </button>
        </div>
    </div>
</template>

<script>
import AndroidFilePicker from "@/components/Shared/Android-file-picker";
import FadeImage from "@/components/App/fade-image";
import { Form, HasError } from "vform";
import { PlusIcon, XIcon } from "vue-feather-icons";
import objectToFormData from "object-to-formdata";
import { isAndroid } from "mobile-device-detect";
import { dataURLToFile } from "@/mixins/dataURLtoFile.js";
export default {
    name: "new-message",
    mixins: [dataURLToFile],
    components: { AndroidFilePicker, FadeImage, PlusIcon, XIcon, HasError },
    created() {
        if (this.players.length == 0) {
            this.getPlayers();
        }
        if (this.$route.query.id) {
            this.form.player = this.$route.query.id;
        }

        if (this.offers.length == 0) {
            this.$store.dispatch("getOffers");
        }
        this.getGroups();

        this.oWebViewInterface.on("fileRecieved-content-message-image", (imageData) => {
            console.log(imageData);
            this.androidFilePickerOpen = false;

            var file = this.dataURLToFile("data:text/plain;base64," + imageData, "aaron.png");
            this.form.image = file;
            this.form.image_url = URL.createObjectURL(file);
        });
    },
    data() {
        return {
            msgActive: false,
            offer: false,
            androidFilePickerOpen: false,
            oWebViewInterface: window.nsWebViewInterface,
            form: new Form({
                player: "",
                group: "",
                msg: "",
                offer_id: "",
                image: false,
                image_url: false,
            }),
        };
    },
    computed: {
        isSinglePlayer() {
            return this.$route.query.id ? true : false;
        },
        players() {
            return this.$store.state.players;
        },
        offers() {
            return this.$store.state.offers;
        },
        groups() {
            return this.$store.state.groups;
        },
    },
    methods: {
        openFileAndroid() {
            if (isAndroid) {
                this.androidFilePickerOpen = true;
            }
        },
        removeImage() {
            this.form.image = false;
            this.form.image_url = false;
        },
        resetTo(type) {
            if (type == "player" && this.form.player) {
                this.form.group = "";
            }
            if (type == "group" && this.form.group) {
                this.form.player = "";
            }
        },
        selectOffer() {
            var index = this.$store.state.offers.findIndex((offer) => {
                return offer.id == this.form.offer_id;
            });

            if (index > -1) {
                this.offer = this.$store.state.offers[index];
            } else {
                this.offer = false;
            }

            this.form.offer_id = "";
        },
        getGroups() {
            this.form.get("/group").then((groups) => {
                this.$store.dispatch("getGroups", groups.data);

                if (this.form.group) {
                    const selected = groups.data.find((group) => group.id == this.form.group);

                    if (!selected || this.groupHasNoMembers(selected)) {
                        this.form.group = "";
                    }
                }
            });
        },
        groupHasNoMembers(group) {
            return group.members_count === 0;
        },
        groupLabel(group) {
            return this.groupHasNoMembers(group) ? `${group.name} (no members)` : group.name;
        },
        selectImage() {
            var file = event.target.files[0];
            this.form.image = file;
            this.form.image_url = URL.createObjectURL(event.target.files[0]);
        },
        goToLocation($url) {
            if (this.$route.query.from) {
                this.$router.go(-1);
            } else {
                this.$router.push($url);
            }
        },
        getPlayers() {
            this.$store.dispatch("getPlayers");
        },
        sendMessage() {
            this.form.offer_id = this.offer.id;

            this.form
                .submit("POST", "/message", {
                    transformRequest: [
                        function (data) {
                            return objectToFormData(data);
                        },
                    ],
                })
                .then((response) => {
                    this.form.player = "";
                    this.form.group = "";
                    this.form.msg = "";
                    this.form.image = false;
                    this.form.image_url = false;
                    this.$store.dispatch("addSentMessage", response.data);
                    this.$router.push({ name: "proPlayerMessagesSent" });
                    this.$notify({
                        duration: 1000,
                        text: "Your message has been sent!",
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#newMessage {
    select {
        margin-bottom: 20px;
    }
    .offer {
        margin-bottom: 20px;

        color: #60c45c;
    }
    .addImage {
        margin-right: 0px;
        input[type="file"] {
            display: none;
        }
        &.red {
            background: #bd6262;
            color: white;
        }
    }
    .msButton2 {
        font-family: canada-type-gibson, sans-serif;
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 10px;

        &.selected {
            background: white;
        }
    }

    .msgSelectSurround {
        width: calc(50% - 5px);
        display: inline-block;
        position: relative;
        margin-right: 10px;
        float: left;
        .icon {
            position: absolute;
            top: 8px;
            right: 10px;
            width: 15px;
            pointer-events: none;
            color: #267962;
        }
    }
    .msgButton {
        font-size: 14px;
        height: 40px !important;
        border-radius: 8px;
        margin-bottom: 0px;

        &.first {
            padding: 10px 12px !important;
        }
        &.last {
            padding: 13px 12px !important;
        }
        .icon {
            width: 15px;
        }
    }
    .attachedImage {
        max-width: 100%;
        display: block;
        margin: 0 auto;
        margin-top: 20px;
        border-radius: 12px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
        background-size: cover;
    }
    .messageBox {
        background: white;
        padding: 20px;
        border-radius: $radius;
        margin-bottom: 20px;

        &.active {
            box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
        }
        textarea {
            width: 100%;
            max-width: 100%;
            border: 0px;
            min-height: 100px;
            font-size: 1rem;
            font-family: canada-type-gibson, sans-serif;
            line-height: 1.5;
            color: $green_0;
            &:focus {
                outline: 0;
            }
        }
    }
}
</style>
